import { render } from "./linkerManage.vue?vue&type=template&id=3c355dd4&scoped=true"
import script from "./linkerManage.vue?vue&type=script&lang=js"
export * from "./linkerManage.vue?vue&type=script&lang=js"

import "./linkerManage.vue?vue&type=style&index=0&id=3c355dd4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c355dd4"]])

export default __exports__